
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_45683","data-name":"Group 45683","transform":"translate(-1146 -2185)"}},[_c('path',{attrs:{"id":"Path_32744","data-name":"Path 32744","d":"M0 0h30v30H0z","transform":"translate(1146 2185)","fill":"none"}}),_c('path',{attrs:{"id":"Path_32742","data-name":"Path 32742","d":"M25.979 22.221a3.053 3.053 0 00-2.13-2.158v-2.437a.751.751 0 000-.4V9.517a3.052 3.052 0 10-3.8-3.64H9.948A3.054 3.054 0 106.091 9.5v10.581a3.052 3.052 0 103.829 3.706h10.158a3.053 3.053 0 105.9-1.566m-4.34-16.343a1.555 1.555 0 112.21 2.022 1.52 1.52 0 01-1.5.085 1.576 1.576 0 01-.888-1.4 1.527 1.527 0 01.178-.709M9.92 7.377h10.158a3.055 3.055 0 002.271 2.188v6.012l-1.127-1.126a2.706 2.706 0 00-3.735 0l-.653.653-2.534-2.53a2.676 2.676 0 00-3.7 0L7.591 15.59V9.583A3.061 3.061 0 009.92 7.377m-4.5-.791a1.555 1.555 0 011.55-1.56h.01a1.558 1.558 0 11-1.56 1.56m1.56 17.968A1.547 1.547 0 118.54 23a1.579 1.579 0 01-1.56 1.559m13.069-2.267h-10.1A3.068 3.068 0 007.591 20v-2.289l4.076-4.076a1.139 1.139 0 011.576 0l3.023 3.022.036.039a.333.333 0 00.04.036l1.176 1.177a.75.75 0 001.061-1.061l-.684-.683.653-.653a1.167 1.167 0 011.614 0l2.187 2.188v2.316a3.061 3.061 0 00-2.3 2.273m4.36 1.42a1.558 1.558 0 01-1.389.847A1.578 1.578 0 0121.46 23a1.52 1.52 0 01.178-.708 1.557 1.557 0 112.771 1.42","transform":"translate(1146 2185)"}}),_c('path',{attrs:{"id":"Path_32743","data-name":"Path 32743","d":"M16.806 12.226a1.061 1.061 0 10-1.061-1.062 1.063 1.063 0 001.061 1.062","transform":"translate(1146 2185)"}})])])
          )
        }
      }
    